/* eslint-disable react/button-has-type */
/* eslint-disable @typescript-eslint/no-var-requires */
import React from 'react';

import './component004.less';
interface IComponents004Props {
  img: string;
  img1: string;
  className?: string;
}

const Components004: React.FunctionComponent<IComponents004Props> = ({
  img,
  img1,
  className,
}) => (
  <>
    <div className={`RealCase Desktop ${className}`}>
      <img src={require(`../../../../../assets/${img}`).default} alt="" />
      <button
        onClick={() => {
          window.open(
            'https://chungyeungsiu.medium.com/%E5%AE%A3%E9%81%93zoom%E8%AA%B2%E5%A0%82%E8%A2%AB%E9%BB%91%E5%AE%A2%E5%85%A5%E4%BE%B5-d98c091dbbcb'
          );
        }}
        className="source1"
      />
      <button
        onClick={() => {
          window.open(
            'https://ezone.ulifestyle.com.hk/article/2629646/Zoom%20%E5%86%8D%E7%8F%BE%E5%AE%89%E5%85%A8%E6%BC%8F%E6%B4%9E%20%E4%B8%AD%E5%A4%A7%E5%AD%B8%E7%94%9F%E8%80%83%E8%A9%A6%E6%9C%9F%E9%96%93%E8%A2%AB%E9%BB%91%E5%AE%A2%E5%85%A5%E4%BE%B5%E8%AE%8A%E7%9D%87%20AV%EF%BC%9F'
          );
        }}
        className="source2"
      />
      <button
        onClick={() => {
          window.open(
            'https://news.mingpao.com/ins/%E6%B8%AF%E8%81%9E/article/20220504/s00001/1651676200845/%E5%82%B3%E7%9C%9F%E7%A4%BE%E7%B3%BB%E7%B5%B1%E9%81%AD%E9%BB%91%E5%AE%A2%E5%85%A5%E4%BE%B5-%E6%B4%A93700%E8%A8%82%E6%88%B6%E9%9B%BB%E9%83%B5'
          );
        }}
        className="source3"
      />
      <button
        onClick={() => {
          window.open(
            'https://inews.hket.com/article/3087336/%E3%80%90%E7%B6%B2%E7%B5%A1%E5%AE%89%E5%85%A8%E3%80%91%E6%95%B8%E7%A2%BC%E7%87%9F%E9%8A%B7%E5%85%AC%E5%8F%B8Fimmick%E7%B3%BB%E7%B5%B1%E9%81%AD%E5%8B%92%E7%B4%A2%E8%BB%9F%E4%BB%B6%E6%94%BB%E6%93%8A%E3%80%80%E9%80%BE3.5%E8%90%AC%E4%BA%BA%E8%B3%87%E6%96%99%E6%88%96%E5%A4%96%E6%B4%A9'
          );
        }}
        className="source4"
      />
    </div>
    <div className={`RealCase Moblie ${className}`}>
      <img src={require(`../../../../../assets/${img1}`).default} alt="" />
      <button
        onClick={() => {
          window.open(
            'https://chungyeungsiu.medium.com/%E5%AE%A3%E9%81%93zoom%E8%AA%B2%E5%A0%82%E8%A2%AB%E9%BB%91%E5%AE%A2%E5%85%A5%E4%BE%B5-d98c091dbbcb'
          );
        }}
        className="source1"
      />
      <button
        onClick={() => {
          window.open(
            'https://ezone.ulifestyle.com.hk/article/2629646/Zoom%20%E5%86%8D%E7%8F%BE%E5%AE%89%E5%85%A8%E6%BC%8F%E6%B4%9E%20%E4%B8%AD%E5%A4%A7%E5%AD%B8%E7%94%9F%E8%80%83%E8%A9%A6%E6%9C%9F%E9%96%93%E8%A2%AB%E9%BB%91%E5%AE%A2%E5%85%A5%E4%BE%B5%E8%AE%8A%E7%9D%87%20AV%EF%BC%9F'
          );
        }}
        className="source2"
      />
      <button
        onClick={() => {
          window.open(
            'https://news.mingpao.com/ins/%E6%B8%AF%E8%81%9E/article/20220504/s00001/1651676200845/%E5%82%B3%E7%9C%9F%E7%A4%BE%E7%B3%BB%E7%B5%B1%E9%81%AD%E9%BB%91%E5%AE%A2%E5%85%A5%E4%BE%B5-%E6%B4%A93700%E8%A8%82%E6%88%B6%E9%9B%BB%E9%83%B5'
          );
        }}
        className="source3"
      />
      <button
        onClick={() => {
          window.open(
            'https://inews.hket.com/article/3087336/%E3%80%90%E7%B6%B2%E7%B5%A1%E5%AE%89%E5%85%A8%E3%80%91%E6%95%B8%E7%A2%BC%E7%87%9F%E9%8A%B7%E5%85%AC%E5%8F%B8Fimmick%E7%B3%BB%E7%B5%B1%E9%81%AD%E5%8B%92%E7%B4%A2%E8%BB%9F%E4%BB%B6%E6%94%BB%E6%93%8A%E3%80%80%E9%80%BE3.5%E8%90%AC%E4%BA%BA%E8%B3%87%E6%96%99%E6%88%96%E5%A4%96%E6%B4%A9'
          );
        }}
        className="source4"
      />
    </div>
  </>
);

export default Components004;
